const CreateNewIdentityRequest = function() {
  return {
    leadPartyDTO: {
      name: "",
      surname: "",
      phone: "",
      phoneCountryCode: "",
      email: "",
      addressCode: "",
      investmentConsultant: "",
      channel: "",
      hasNFCPhone: false,
      primaryContactType: "",
      assignedUnitCode: "",
      assignedId: "",
      assignedName: "",
      domainId: ""
    }
  };
};

export default CreateNewIdentityRequest;



// WEBPACK FOOTER //
// ./src/service/request/CreateNewIdentityRequest.js